module.exports = __webpack_public_path__ + "img/broccoli-mobile.53ebb7e3.png";